var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g, _g2, _path38, _path39, _g3, _g4, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetInTouch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400.48489,
    height: 308.21307,
    viewBox: "0 0 400.48489 308.21307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "figure",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 98.071723,125.17306 C 123.16172,92.093061 110.37172,14.523061 157.32172,1.4330613 c 42.75,-11.9000003 53.86,53.9999997 83.76,61.6599997 37.2,9.53 110.41,-61.9299997 152.28,-16.19 40.57,44.31 -103,160.079999 -157.36,182.169999 -86.29,35.08 -240.950097,22.48 -235.88009702,-41.84 3.40000002,-43.18 76.33010002,-33.56 97.95010002,-62.06 z",
    fill: "#ffffff",
    fillOpacity: 0.2,
    id: "path387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 196.41172,308.21306 c 107.083,0 193.89,-5.068 193.89,-11.32 0,-6.252 -86.807,-11.32 -193.89,-11.32 -107.081997,0 -193.889997,5.068 -193.889997,11.32 0,6.252 86.808,11.32 193.889997,11.32 z",
    fill: "#f5f5f5",
    fillOpacity: 0.25,
    id: "path389"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 273.01172,80.113061 c -2.69,-2.8 -4.6,-8 -5.53,-11.35 l -4.25,10.14 c 0.683,0.789 1.179,1.723 1.449,2.731 0.27,1.008 0.308,2.064 0.111,3.089 0,0.09 -0.15,1.79 -3,3.53 0,0 0.51,10.26 6.62,8.81 6.11,-1.45 9.43,-13.63 9.43,-13.63 l 0.44,-3.45 c 0,0 -2.78,2.34 -5.27,0.13 z",
    fill: "#ffc3bd",
    id: "path391"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m 264.30172,76.423061 -1,2.48 c 0.8,0.959 1.343,2.104 1.58,3.33 2.8,-3.3 3.11,-8.64 3.11,-8.64 z",
    fill: "#000000",
    id: "path393"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 219.94172,125.77306 c 0,0 16.49,0.67 23.81,-1.33 7.32,-2 13.54,-14.81 13.54,-14.81 l -8.35,-4.61 -8.3,12.35 -20.68,3.31 -5.94,-4.18 c 0,0 -12,-2.56 -12,-1 0,1.56 6.19,2.82 6.19,2.82 0,0 0.37,7.38 2.91,7.61 2.54,0.23 8.82,-0.16 8.82,-0.16 z",
    fill: "#ffc3bd",
    id: "path395"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 260.30172,90.503061 c 0,0 -7.14,1 -11.81,9.649999 -4.67,8.65 -0.68,9 3.27,11.44 3.95,2.44 5.93,3 7.75,-2.34 1.82,-5.34 5.41,-19.299999 0.79,-18.749999 z",
    fill: "#ffffff",
    id: "path397"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m 260.28172,106.81306 -2.65,-5.4 -4.45,-0.34 c -0.215,3.82 -0.138,7.651 0.23,11.46 2.89,1.51 4.56,1.21 6.1,-3.3 0.23,-0.68 0.5,-1.5 0.77,-2.42 z",
    fill: "#000000",
    id: "path399"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 246.06172,56.043061 c 0,0 -5.2,1.84 -1.76,7.13 3.44,5.29 -3.5,8.89 8.15,10.35 11.65,1.46 0.41,-19.61 0.41,-19.61 z",
    fill: "url(#paint0_linear_190_1420)",
    id: "path401",
    style: {
      fill: "url(#paint0_linear_190_1420)"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m 246.06172,56.043061 c 0,0 -5.2,1.84 -1.76,7.13 3.44,5.29 -3.5,8.89 8.15,10.35 11.65,1.46 0.41,-19.61 0.41,-19.61 z",
    fill: "#000000",
    id: "path403"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m 290.85172,89.243061 c -1.74,-11.32 -8.33,-11.12 -14.75,-8.59 0.45,4.26 0.46,9.7 -5.71,13.09 -5.55,3 -7.71,-2 -7.83,-6.22 -5.82,3.31 -10.68,7.55 -9.09,15.999999 0.91,4.8 5.15,10.07 9.49,16.76 5.19,8 10.53,17.08 10.53,17.08 l 29.66,-15.1 c 0,0 -10.41,-20.76 -12.3,-33.019999 z",
    fill: "#ffffff",
    id: "path405"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 290.85172,89.243061 c -0.21,-1.459 -0.569,-2.893 -1.07,-4.28 l -4.49,-0.76 -2.34,3.72 c 0,0 4.95,8.72 11.53,14.229999 -1.607,-4.181999 -2.822,-8.503999 -3.63,-12.909999 z",
    fill: "#000000",
    id: "path407"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m 298.78172,85.643061 c 0,0 10.18,7 13.29,9.65 4.63,4 17.1,17.469999 17.1,17.469999 l 7.65,4.18 v 4.84 l -3.62,2.5 c -0.264,0.183 -0.562,0.311 -0.877,0.377 -0.314,0.066 -0.639,0.069 -0.954,0.009 -0.316,-0.061 -0.616,-0.183 -0.884,-0.361 -0.267,-0.178 -0.497,-0.407 -0.675,-0.675 l -4.64,-6.93 c 0,0 -11.44,-10.45 -15.65,-13.43 -3.56,-2.52 -15.1,-8.709999 -15.1,-8.709999 z",
    fill: "#ffc3bd",
    id: "path409"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m 279.99172,79.603061 c 0,0 6.56,-2.95 12.15,0 5.59,2.95 8.06,4.57 7.51,8.13 -0.55,3.56 -2.6,10.92 -6.28,9.7 -3.68,-1.22 -15.42,-12.87 -13.38,-17.83 z",
    fill: "#ffffff",
    id: "path411"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m 269.03172,60.323061 c 0.76,7.67 1.25,10.89 -1.95,15.4 -4.82,6.79 -14.4,6.05 -17.43,-1.23 -2.74,-6.56 -3.52,-18 3.42,-22.2 1.523,-0.949 3.265,-1.492 5.058,-1.576 1.792,-0.084 3.577,0.293 5.182,1.096 1.606,0.803 2.978,2.004 3.987,3.488 1.008,1.485 1.619,3.204 1.773,4.992 z",
    fill: "#ffc3bd",
    id: "path413"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m 252.92172,66.183061 c -0.321,1.498 -0.846,2.945 -1.56,4.3 0.349,0.176 0.732,0.274 1.122,0.286 0.391,0.012 0.779,-0.061 1.138,-0.216 z",
    fill: "#ed893e",
    id: "path415"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 258.04172,61.063061 c 0.046,-0.026 0.084,-0.064 0.11,-0.11 0.037,-0.069 0.047,-0.151 0.026,-0.227 -0.02,-0.076 -0.069,-0.141 -0.136,-0.183 -0.49,-0.296 -1.043,-0.47 -1.614,-0.506 -0.571,-0.037 -1.143,0.065 -1.666,0.296 -0.071,0.04 -0.124,0.106 -0.149,0.184 -0.024,0.078 -0.017,0.163 0.019,0.236 0.036,0.07 0.099,0.123 0.173,0.147 0.075,0.024 0.157,0.018 0.227,-0.017 0.437,-0.184 0.911,-0.262 1.384,-0.227 0.473,0.035 0.931,0.181 1.336,0.427 0.046,0.023 0.097,0.033 0.148,0.029 0.051,-0.003 0.1,-0.02 0.142,-0.049 z",
    fill: "url(#paint1_linear_190_1420)",
    id: "path417",
    style: {
      fill: "url(#paint1_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 246.59172,63.003061 0.13,-0.1 c 0.297,-0.364 0.675,-0.653 1.104,-0.844 0.429,-0.191 0.897,-0.279 1.366,-0.256 0.081,0.012 0.163,-0.009 0.228,-0.058 0.066,-0.049 0.11,-0.121 0.122,-0.202 0.003,-0.081 -0.023,-0.161 -0.075,-0.223 -0.052,-0.063 -0.125,-0.105 -0.205,-0.117 -0.569,-0.031 -1.137,0.072 -1.658,0.301 -0.521,0.229 -0.981,0.579 -1.342,1.019 -0.056,0.058 -0.087,0.135 -0.087,0.215 0,0.08 0.031,0.157 0.087,0.215 0.045,0.039 0.099,0.065 0.157,0.075 0.058,0.011 0.118,0.006 0.173,-0.015 z",
    fill: "url(#paint2_linear_190_1420)",
    id: "path419",
    style: {
      fill: "url(#paint2_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 257.12172,64.503061 c 0.1,0.61 -0.15,1.16 -0.56,1.23 -0.41,0.07 -0.81,-0.37 -0.9,-1 -0.09,-0.63 0.14,-1.16 0.54,-1.23 0.4,-0.07 0.81,0.34 0.92,1 z",
    fill: "url(#paint3_linear_190_1420)",
    id: "path421",
    style: {
      fill: "url(#paint3_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 250.13172,65.593061 c 0.1,0.61 -0.15,1.16 -0.55,1.23 -0.4,0.07 -0.8,-0.38 -0.91,-1 -0.11,-0.62 0.15,-1.17 0.55,-1.23 0.4,-0.06 0.82,0.37 0.91,1 z",
    fill: "url(#paint4_linear_190_1420)",
    id: "path423",
    style: {
      fill: "url(#paint4_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 249.40172,64.593061 -1.55,-0.18 c 0,0 0.95,1.03 1.55,0.18 z",
    fill: "url(#paint5_linear_190_1420)",
    id: "path425",
    style: {
      fill: "url(#paint5_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 256.39172,63.503061 -1.55,-0.18 c 0,0 0.95,0.99 1.55,0.18 z",
    fill: "url(#paint6_linear_190_1420)",
    id: "path427",
    style: {
      fill: "url(#paint6_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 258.61172,73.393061 c 0.38,-0.185 0.742,-0.406 1.08,-0.66 0.024,-0.017 0.044,-0.038 0.06,-0.063 0.015,-0.025 0.025,-0.053 0.03,-0.082 0.005,-0.028 0.004,-0.058 -0.003,-0.086 -0.007,-0.029 -0.02,-0.056 -0.037,-0.079 -0.042,-0.039 -0.098,-0.06 -0.155,-0.06 -0.057,0 -0.113,0.021 -0.155,0.06 -0.746,0.572 -1.617,0.96 -2.541,1.134 -0.924,0.174 -1.876,0.128 -2.779,-0.134 -0.027,-0.011 -0.056,-0.017 -0.085,-0.018 -0.029,0 -0.058,0.006 -0.085,0.017 -0.027,0.011 -0.052,0.028 -0.072,0.048 -0.021,0.021 -0.037,0.046 -0.048,0.073 -0.013,0.027 -0.019,0.057 -0.02,0.087 0,0.03 0.006,0.06 0.019,0.088 0.012,0.027 0.03,0.052 0.053,0.072 0.022,0.02 0.049,0.034 0.078,0.043 1.552,0.465 3.223,0.307 4.66,-0.44 z",
    fill: "url(#paint7_linear_190_1420)",
    id: "path429",
    style: {
      fill: "url(#paint7_linear_190_1420)"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m 252.49172,56.123061 c -3,0.36 -11,2.64 -9.73,-4.82 1.27,-7.46 15.56,-11.19 22.2,-6.37 6.64,4.82 11.74,4.46 17,0.55 5.26,-3.91 7.82,-2.37 14.56,1.27 0,0 -3.64,6.28 -1.91,10.1 0,0 -4,-4 -11.47,0.27 0,0 8.64,-2.29 11.92,3.68 0,0 -0.91,6.59 2.27,10.51 3.18,3.92 -0.09,8.56 -12.28,3.83 -12.19,-4.73 -13.49,-0.39 -16.3,-2.48 -2.81,-2.09 -4.92,-7.75 -5.36,-11.86 -0.28,-2.96 -1.61,-5.78 -10.9,-4.68 z",
    fill: "#000000",
    id: "path431"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m 270.08172,65.593061 c -0.096,0.733 -0.335,1.439 -0.704,2.079 -0.369,0.64 -0.86,1.201 -1.446,1.651 -1.57,1.18 -3.08,0 -3.24,-1.91 -0.15,-1.67 0.49,-4.31 2.36,-4.77 0.412,-0.085 0.838,-0.066 1.241,0.055 0.403,0.121 0.77,0.339 1.067,0.637 0.298,0.297 0.516,0.664 0.637,1.067 0.121,0.403 0.14,0.829 0.055,1.241 z",
    fill: "#ffc3bd",
    id: "path433"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m 310.23172,277.50306 c 0.26,6.39 0.45,11.46 0.45,11.46 l -7.1,0.81 c 0,0 -0.68,-4.32 -1.7,-10.95 z",
    fill: "#ffc3bd",
    id: "path435"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m 300.46172,288.23306 c -0.732,0.134 -1.487,-0.008 -2.12,-0.4 -0.076,-0.107 -0.116,-0.234 -0.116,-0.365 0,-0.131 0.04,-0.258 0.116,-0.365 0.049,-0.102 0.119,-0.193 0.205,-0.267 0.086,-0.074 0.187,-0.13 0.295,-0.163 1.17,-0.4 3.73,0.85 3.84,0.91 0.032,0.016 0.058,0.04 0.076,0.07 0.017,0.03 0.026,0.065 0.024,0.1 -0.004,0.034 -0.018,0.066 -0.042,0.092 -0.023,0.025 -0.054,0.042 -0.088,0.048 -0.718,0.18 -1.451,0.294 -2.19,0.34 z m -1.21,-1.3 c -0.109,0 -0.218,0.02 -0.32,0.06 -0.069,0.014 -0.134,0.044 -0.19,0.087 -0.055,0.043 -0.1,0.099 -0.13,0.163 -0.11,0.22 -0.06,0.32 0,0.37 0.36,0.44 2.15,0.34 3.46,0.09 -0.89,-0.432 -1.853,-0.693 -2.84,-0.77 z",
    fill: "#ffffff",
    id: "path437"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m 302.59172,287.89306 h -0.07 c -0.87,-0.32 -2.67,-1.75 -2.57,-2.56 0,-0.19 0.13,-0.43 0.59,-0.51 0.173,-0.036 0.353,-0.034 0.525,0.006 0.173,0.039 0.335,0.116 0.475,0.224 0.697,0.732 1.142,1.667 1.27,2.67 0.007,0.025 0.007,0.05 0,0.075 -0.007,0.025 -0.02,0.047 -0.039,0.064 -0.018,0.018 -0.041,0.03 -0.066,0.035 -0.025,0.006 -0.051,0.004 -0.075,-0.004 z m -1.92,-2.76 h -0.09 c -0.3,0 -0.32,0.17 -0.32,0.21 0,0.48 1.18,1.62 2.09,2.08 -0.134,-0.798 -0.511,-1.535 -1.08,-2.11 -0.172,-0.129 -0.385,-0.193 -0.6,-0.18 z",
    fill: "#ffffff",
    id: "path439"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 303.28172,286.85306 7.74,-0.49 c 0.142,-0.01 0.283,0.029 0.4,0.111 0.116,0.082 0.201,0.202 0.24,0.339 l 1.81,6.21 c 0.044,0.13 0.061,0.269 0.049,0.406 -0.011,0.137 -0.051,0.271 -0.117,0.392 -0.066,0.121 -0.156,0.227 -0.265,0.312 -0.108,0.085 -0.233,0.146 -0.367,0.18 -0.073,0.009 -0.147,0.009 -0.22,0 -2.79,0.13 -5.29,0.14 -8.76,0.36 -4.1,0.27 -3,0.69 -7.85,1.07 -2.9,0.22 -3.64,-3 -2.42,-3.29 5.59,-1.07 6.07,-2.81 8.11,-5 0.463,-0.386 1.047,-0.598 1.65,-0.6 z",
    fill: "url(#paint8_linear_190_1420)",
    id: "path441",
    style: {
      fill: "url(#paint8_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 305.93172,126.68306 -1.35,-4.85 c -0.042,-0.137 -0.113,-0.262 -0.208,-0.369 -0.095,-0.107 -0.212,-0.192 -0.343,-0.25 -0.131,-0.058 -0.273,-0.087 -0.416,-0.085 -0.143,0.001 -0.284,0.033 -0.413,0.094 l -30.26,15.28 c -0.122,0.066 -0.229,0.157 -0.314,0.266 -0.085,0.109 -0.147,0.235 -0.181,0.37 -0.034,0.134 -0.039,0.274 -0.016,0.411 0.023,0.137 0.075,0.267 0.151,0.383 l 3.06,4.45 c 0,0 7.51,51.12 10.59,68.12 3.18,17.33 14.56,69.19 14.56,69.19 0.036,0.185 0.144,0.348 0.299,0.454 0.155,0.107 0.346,0.148 0.531,0.116 l 8.81,-1.42 c 0.167,-0.028 0.319,-0.113 0.431,-0.24 0.111,-0.128 0.174,-0.291 0.179,-0.46 0.1,-4.42 0,-32.36 -2.78,-52.13 -1,-7.06 -3.38,-12.72 -4.19,-16.61 -0.89,-4.29 0.49,-7.17 1,-17.5 1.1,-19.4 2.32,-50.1 0.86,-65.22 z",
    fill: "url(#paint9_linear_190_1420)",
    id: "path443",
    style: {
      fill: "url(#paint9_linear_190_1420)"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m 305.14172,191.94306 c 0.35,-6.51 0.71,-14.27 1,-22.29 l -8.78,-14.8 -3.91,-8.74 -3.7,5 c 0,0 6.54,27.51 15.13,44.79 0.09,-1.16 0.19,-2.48 0.26,-3.96 z",
    fill: "#000000",
    id: "path445"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m 371.73172,253.04306 c 3.68,5.23 6.07,8.67 6.07,8.67 l -5.57,4.52 -7.36,-8.28 z",
    fill: "#ffc3bd",
    id: "path447"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m 368.39172,266.58306 c -0.543,0.509 -1.256,0.797 -2,0.81 -0.126,-0.042 -0.235,-0.123 -0.312,-0.23 -0.077,-0.108 -0.118,-0.237 -0.118,-0.37 -0.02,-0.227 0.048,-0.452 0.19,-0.63 0.77,-1 3.6,-1.3 3.73,-1.32 0.036,-0.005 0.072,0.003 0.102,0.021 0.031,0.018 0.055,0.046 0.068,0.079 0.019,0.028 0.029,0.061 0.029,0.095 0,0.034 -0.01,0.067 -0.029,0.095 -0.512,0.529 -1.067,1.014 -1.66,1.45 z m -1.73,-0.44 c -0.089,0.063 -0.17,0.137 -0.24,0.22 -0.046,0.053 -0.08,0.115 -0.101,0.183 -0.02,0.067 -0.027,0.137 -0.019,0.207 0,0.24 0.12,0.3 0.19,0.32 0.54,0.17 2,-0.88 3,-1.8 -0.99,0.106 -1.951,0.401 -2.83,0.87 z",
    fill: "#ffffff",
    id: "path449"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m 370.00172,265.14306 h -0.06 c -0.91,0.2 -3.2,0 -3.55,-0.76 -0.1,-0.17 -0.13,-0.44 0.22,-0.75 0.123,-0.114 0.268,-0.202 0.426,-0.259 0.158,-0.056 0.326,-0.08 0.494,-0.071 0.986,0.241 1.872,0.787 2.53,1.56 0.015,0.026 0.023,0.055 0.023,0.085 0,0.03 -0.008,0.059 -0.023,0.085 -0.008,0.042 -0.029,0.081 -0.06,0.11 z m -3.11,-1.28 -0.08,0.05 c -0.23,0.2 -0.18,0.31 -0.16,0.35 0.25,0.41 1.87,0.72 2.89,0.61 -0.553,-0.593 -1.27,-1.008 -2.06,-1.19 -0.212,-0.011 -0.421,0.053 -0.59,0.18 z",
    fill: "#ffffff",
    id: "path451"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 370.01172,263.90306 6.25,-4.61 c 0.11,-0.089 0.248,-0.138 0.39,-0.138 0.142,0 0.28,0.049 0.39,0.138 l 4.87,4.25 c 0.108,0.085 0.197,0.192 0.262,0.313 0.065,0.121 0.105,0.254 0.116,0.391 0.011,0.137 -0.006,0.275 -0.05,0.405 -0.045,0.13 -0.115,0.25 -0.208,0.351 -0.048,0.055 -0.102,0.106 -0.16,0.15 -2.28,1.62 -4.38,3 -7.18,5.05 -3.3,2.44 -2.17,2.22 -6,5.14 -2.32,1.76 -4.71,-0.59 -3.82,-1.45 4.13,-3.93 3.59,-5.65 4.14,-8.57 0.154,-0.577 0.509,-1.08 1,-1.42 z",
    fill: "url(#paint10_linear_190_1420)",
    id: "path453",
    style: {
      fill: "url(#paint10_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 283.77172,139.02306 c 0,0 23.17,53.41 34.12,69.33 9.73,14.14 46.67,50.32 46.67,50.32 0.273,0.294 0.649,0.471 1.049,0.496 0.4,0.024 0.795,-0.107 1.101,-0.366 l 5.13,-4.36 c 0.281,-0.242 0.467,-0.575 0.526,-0.942 0.058,-0.366 -0.015,-0.741 -0.206,-1.058 -3.15,-5.13 -16.41,-26.46 -28.05,-40.34 -4.64,-5.53 -9.1,-9.59 -11.3,-12.64 -2.89,-4 -2.21,-7.26 -4.5,-18.45 -4.26,-20.81 -12.56,-51.41 -25.16,-56.3 z",
    fill: "url(#paint11_linear_190_1420)",
    id: "path455",
    style: {
      fill: "url(#paint11_linear_190_1420)"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m 239.04172,289.93306 h -94.39 c -1.514,0.028 -3.017,-0.268 -4.407,-0.866 -1.391,-0.599 -2.639,-1.487 -3.66,-2.605 -1.02,-1.119 -1.791,-2.442 -2.261,-3.881 -0.47,-1.44 -0.627,-2.963 -0.462,-4.468 l 20.74,-236.999999 c 0.325,-3.204 1.813,-6.177 4.183,-8.357 2.37,-2.18 5.457,-3.416 8.677,-3.473 h 94.39 c 1.515,-0.028 3.018,0.268 4.41,0.867 1.392,0.599 2.639,1.488 3.661,2.608 1.021,1.119 1.791,2.443 2.26,3.884 0.469,1.441 0.625,2.965 0.459,4.471 l -20.74,236.999999 c -0.327,3.202 -1.817,6.173 -4.186,8.351 -2.37,2.178 -5.456,3.412 -8.674,3.469 z",
    fill: "#ffffff",
    id: "path457"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m 261.85172,29.243061 h -94.39 c -3.22,0.057 -6.307,1.293 -8.677,3.473 -2.37,2.18 -3.858,5.153 -4.183,8.357 l -20.74,236.999999 c -0.165,1.505 -0.008,3.028 0.462,4.468 0.47,1.439 1.241,2.762 2.261,3.881 1.021,1.118 2.269,2.006 3.66,2.605 1.39,0.598 2.893,0.894 4.407,0.866 h 94.39 c 3.218,-0.057 6.304,-1.291 8.674,-3.469 2.369,-2.178 3.859,-5.149 4.186,-8.351 l 20.74,-236.999999 c 0.166,-1.506 0.01,-3.03 -0.459,-4.471 -0.469,-1.441 -1.239,-2.765 -2.26,-3.884 -1.022,-1.12 -2.269,-2.009 -3.661,-2.608 -1.392,-0.599 -2.895,-0.895 -4.41,-0.867 z m -15.2,248.869999 c -0.183,1.78 -1.012,3.431 -2.329,4.641 -1.317,1.211 -3.032,1.897 -4.821,1.929 h -94.39 c -0.842,0.015 -1.677,-0.15 -2.45,-0.482 -0.773,-0.333 -1.466,-0.827 -2.034,-1.448 -0.567,-0.622 -0.996,-1.357 -1.257,-2.157 -0.262,-0.8 -0.35,-1.646 -0.259,-2.483 l 20.74,-236.999999 c 0.181,-1.781 1.008,-3.435 2.326,-4.647 1.317,-1.213 3.034,-1.901 4.824,-1.933 h 94.39 c 0.842,-0.015 1.678,0.15 2.452,0.483 0.774,0.333 1.468,0.828 2.036,1.451 0.567,0.622 0.996,1.359 1.257,2.16 0.26,0.801 0.347,1.649 0.255,2.486 z",
    fill: "#ffffff",
    id: "path459"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "m 261.85172,29.243061 h -94.39 c -3.22,0.057 -6.307,1.293 -8.677,3.473 -2.37,2.18 -3.858,5.153 -4.183,8.357 l -20.74,236.999999 c -0.165,1.505 -0.008,3.028 0.462,4.468 0.47,1.439 1.241,2.762 2.261,3.881 1.021,1.118 2.269,2.006 3.66,2.605 1.39,0.598 2.893,0.894 4.407,0.866 h 94.39 c 3.218,-0.057 6.304,-1.291 8.674,-3.469 2.369,-2.178 3.859,-5.149 4.186,-8.351 l 20.74,-236.999999 c 0.166,-1.506 0.01,-3.03 -0.459,-4.471 -0.469,-1.441 -1.239,-2.765 -2.26,-3.884 -1.022,-1.12 -2.269,-2.009 -3.661,-2.608 -1.392,-0.599 -2.895,-0.895 -4.41,-0.867 z m -15.2,248.869999 c -0.183,1.78 -1.012,3.431 -2.329,4.641 -1.317,1.211 -3.032,1.897 -4.821,1.929 h -94.39 c -0.842,0.015 -1.677,-0.15 -2.45,-0.482 -0.773,-0.333 -1.466,-0.827 -2.034,-1.448 -0.567,-0.622 -0.996,-1.357 -1.257,-2.157 -0.262,-0.8 -0.35,-1.646 -0.259,-2.483 l 20.74,-236.999999 c 0.181,-1.781 1.008,-3.435 2.326,-4.647 1.317,-1.213 3.034,-1.901 4.824,-1.933 h 94.39 c 0.842,-0.015 1.678,0.15 2.452,0.483 0.774,0.333 1.468,0.828 2.036,1.451 0.567,0.622 0.996,1.359 1.257,2.16 0.26,0.801 0.347,1.649 0.255,2.486 z",
    fill: "#ffffff",
    id: "path461"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m 206.02172,275.29306 h -26 c -0.396,0.008 -0.776,0.161 -1.067,0.43 -0.292,0.269 -0.474,0.636 -0.513,1.03 -0.02,0.185 0,0.372 0.058,0.549 0.058,0.177 0.153,0.34 0.279,0.477 0.126,0.137 0.28,0.246 0.451,0.319 0.171,0.073 0.356,0.109 0.542,0.105 h 26 c 0.396,-0.005 0.777,-0.156 1.07,-0.423 0.294,-0.267 0.478,-0.633 0.52,-1.027 0.02,-0.186 0,-0.375 -0.059,-0.553 -0.058,-0.178 -0.154,-0.342 -0.281,-0.48 -0.127,-0.138 -0.282,-0.247 -0.454,-0.321 -0.172,-0.074 -0.359,-0.11 -0.546,-0.106 z",
    fill: "#ffffff",
    id: "path463"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m 205.38172,139.50306 h -27.52 c -0.884,0.017 -1.762,-0.155 -2.574,-0.504 -0.812,-0.35 -1.541,-0.868 -2.137,-1.521 -0.596,-0.653 -1.046,-1.425 -1.32,-2.266 -0.274,-0.841 -0.366,-1.73 -0.269,-2.609 l 2.41,-27.53 c 0.19,-1.868 1.059,-3.602 2.441,-4.873 1.381,-1.271999 3.181,-1.992999 5.059,-2.026999 h 27.53 c 0.883,-0.015 1.76,0.158 2.572,0.508 0.811,0.35 1.539,0.868 2.135,1.519999 0.596,0.653 1.046,1.425 1.321,2.265 0.274,0.84 0.367,1.729 0.272,2.607 l -2.41,27.53 c -0.191,1.87 -1.06,3.605 -2.444,4.877 -1.385,1.271 -3.187,1.991 -5.066,2.023 z",
    fill: "#000000",
    id: "path465"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m 202.38172,136.50306 h -27.52 c -0.884,0.017 -1.762,-0.155 -2.574,-0.504 -0.812,-0.35 -1.541,-0.868 -2.137,-1.521 -0.596,-0.653 -1.046,-1.425 -1.32,-2.266 -0.274,-0.841 -0.366,-1.73 -0.269,-2.609 l 2.41,-27.53 c 0.19,-1.868 1.059,-3.601999 2.441,-4.872999 1.381,-1.272 3.181,-1.993 5.059,-2.027 h 27.53 c 0.883,-0.015 1.76,0.158 2.572,0.508 0.811,0.35 1.539,0.868 2.135,1.52 0.596,0.653 1.046,1.425 1.321,2.265 0.274,0.839999 0.367,1.728999 0.272,2.606999 l -2.41,27.53 c -0.191,1.87 -1.06,3.605 -2.444,4.877 -1.385,1.271 -3.187,1.991 -5.066,2.023 z",
    fill: "#ffffff",
    id: "path467"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 195.05172,113.32306 c 0.47,-5.34 -4,-9.66 -10.1,-9.66 -6.1,0 -11.32,4.32 -11.78,9.66 -0.37,4.21 2.38,7.79 6.53,9.1 -0.576,1.12 -1.493,2.027 -2.62,2.59 0.2,0.123 0.411,0.227 0.63,0.31 1.12,0.363 2.331,0.325 3.426,-0.107 1.094,-0.433 2.005,-1.233 2.574,-2.263 5.84,-0.2 10.89,-4.45 11.34,-9.63 z",
    fill: "url(#paint12_linear_190_1420)",
    id: "path469",
    style: {
      fill: "url(#paint12_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 207.72172,117.94306 c 0.39,-4.4 -3.34,-8 -8.33,-8 -0.877,0.002 -1.75,0.113 -2.6,0.33 0.208,0.986 0.272,1.996 0.19,3 -0.216,1.906 -0.87,3.737 -1.911,5.348 -1.041,1.612 -2.44,2.961 -4.089,3.942 0.759,0.979 1.724,1.779 2.826,2.344 1.103,0.565 2.316,0.881 3.554,0.926 0.152,0.402 0.382,0.77 0.677,1.083 0.294,0.312 0.648,0.564 1.04,0.74 0.392,0.175 0.815,0.272 1.245,0.283 0.429,0.012 0.857,-0.062 1.258,-0.216 0.178,-0.066 0.351,-0.143 0.52,-0.23 -0.754,-0.43 -1.326,-1.12 -1.61,-1.94 3.87,-0.9 6.91,-3.96 7.23,-7.61 z",
    fill: "url(#paint13_linear_190_1420)",
    id: "path471",
    style: {
      fill: "url(#paint13_linear_190_1420)"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m 192.76172,224.70306 h -20.47 c -0.658,0.012 -1.31,-0.115 -1.914,-0.375 -0.605,-0.259 -1.147,-0.645 -1.59,-1.13 -0.444,-0.485 -0.779,-1.06 -0.984,-1.685 -0.204,-0.625 -0.273,-1.286 -0.202,-1.94 l 1.79,-20.47 c 0.142,-1.392 0.789,-2.684 1.819,-3.631 1.03,-0.948 2.372,-1.484 3.771,-1.509 h 20.47 c 0.658,-0.012 1.312,0.116 1.917,0.376 0.605,0.26 1.148,0.646 1.591,1.132 0.444,0.487 0.779,1.063 0.983,1.689 0.204,0.626 0.272,1.289 0.199,1.943 l -1.79,20.47 c -0.142,1.391 -0.789,2.682 -1.82,3.628 -1.03,0.945 -2.372,1.48 -3.77,1.502 z",
    fill: "#000000",
    id: "path473"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m 222.80172,184.86306 h -25.57 c -0.822,0.015 -1.638,-0.145 -2.393,-0.471 -0.755,-0.325 -1.431,-0.807 -1.985,-1.415 -0.554,-0.608 -0.971,-1.326 -1.225,-2.108 -0.254,-0.782 -0.338,-1.609 -0.247,-2.426 l 2.23,-25.59 c 0.178,-1.742 0.99,-3.357 2.28,-4.54 1.29,-1.184 2.969,-1.852 4.72,-1.88 h 25.6 c 0.821,-0.013 1.636,0.148 2.39,0.474 0.755,0.326 1.431,0.808 1.984,1.415 0.553,0.608 0.971,1.326 1.226,2.107 0.254,0.781 0.339,1.607 0.25,2.424 l -2.23,25.59 c -0.179,1.747 -0.995,3.366 -2.291,4.55 -1.297,1.184 -2.983,1.85 -4.739,1.87 z",
    fill: "#000000",
    id: "path475"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m 219.80172,181.86306 h -25.57 c -0.822,0.015 -1.638,-0.145 -2.393,-0.471 -0.755,-0.325 -1.431,-0.807 -1.985,-1.415 -0.554,-0.608 -0.971,-1.326 -1.225,-2.108 -0.254,-0.782 -0.338,-1.609 -0.247,-2.426 l 2.23,-25.59 c 0.178,-1.742 0.99,-3.357 2.28,-4.54 1.29,-1.184 2.969,-1.852 4.72,-1.88 h 25.6 c 0.821,-0.013 1.636,0.148 2.39,0.474 0.755,0.326 1.431,0.808 1.984,1.415 0.553,0.608 0.971,1.326 1.226,2.107 0.254,0.781 0.339,1.607 0.25,2.424 l -2.23,25.59 c -0.179,1.747 -0.995,3.366 -2.291,4.55 -1.297,1.184 -2.983,1.85 -4.739,1.87 z",
    fill: "#ffffff",
    id: "path477"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m 189.76172,221.70306 h -20.47 c -0.658,0.012 -1.31,-0.115 -1.914,-0.375 -0.605,-0.259 -1.147,-0.645 -1.59,-1.13 -0.444,-0.485 -0.779,-1.06 -0.984,-1.685 -0.204,-0.625 -0.273,-1.286 -0.202,-1.94 l 1.79,-20.47 c 0.142,-1.392 0.789,-2.684 1.819,-3.631 1.03,-0.948 2.372,-1.484 3.771,-1.509 h 20.47 c 0.658,-0.012 1.312,0.116 1.917,0.376 0.605,0.26 1.148,0.646 1.591,1.132 0.444,0.487 0.779,1.063 0.983,1.689 0.204,0.626 0.272,1.289 0.199,1.943 l -1.79,20.47 c -0.142,1.391 -0.789,2.682 -1.82,3.628 -1.03,0.945 -2.372,1.48 -3.77,1.502 z",
    fill: "#ffffff",
    id: "path479"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 221.48172,152.09306 h -23.75 c -0.751,-0.003 -1.476,0.276 -2.031,0.781 -0.556,0.506 -0.902,1.201 -0.969,1.949 l -1.33,15.68 c -0.037,0.347 0,0.697 0.109,1.029 0.109,0.331 0.287,0.635 0.522,0.893 0.236,0.257 0.523,0.461 0.844,0.599 0.32,0.137 0.666,0.205 1.015,0.199 h 23.74 c 0.749,0.003 1.473,-0.274 2.028,-0.777 0.555,-0.504 0.902,-1.197 0.972,-1.943 l 1.37,-15.66 c 0.042,-0.352 0.007,-0.708 -0.101,-1.045 -0.109,-0.337 -0.289,-0.647 -0.528,-0.908 -0.239,-0.261 -0.532,-0.468 -0.859,-0.605 -0.326,-0.138 -0.678,-0.203 -1.032,-0.192 z m -18.19,10.54 -7.95,7.31 1.28,-14.62 z m -5.22,-8.65 h 22.73 l -11.49,10.57 c -0.104,0.105 -0.228,0.188 -0.365,0.245 -0.136,0.057 -0.282,0.086 -0.43,0.086 -0.148,0 -0.294,-0.029 -0.431,-0.086 -0.136,-0.057 -0.26,-0.14 -0.364,-0.245 z m 6.44,10 1.75,1.92 c 0.263,0.283 0.582,0.507 0.937,0.658 0.354,0.152 0.737,0.228 1.123,0.222 0.821,-0.005 1.61,-0.32 2.21,-0.88 l 2.09,-1.92 6.7,7.34 h -22.79 z m 9.56,-1.34 8,-7.31 -1.28,14.62 z",
    fill: "url(#paint14_linear_190_1420)",
    id: "path481",
    style: {
      fill: "url(#paint14_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 171.48172,200.82306 6,2.44 6.6,-4.52 -4.96,5.87 3.64,5.14 5.77,-14.32 z",
    fill: "url(#paint15_linear_190_1420)",
    id: "path483",
    style: {
      fill: "url(#paint15_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 177.07172,204.62306 2.7,3.3 h -2.88 z",
    fill: "url(#paint16_linear_190_1420)",
    id: "path485",
    style: {
      fill: "url(#paint16_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 174.68172,208.93306 -0.63,-0.4 c 0.183,-0.297 0.387,-0.581 0.61,-0.85 l 0.57,0.49 c -0.201,0.241 -0.384,0.495 -0.55,0.76 z",
    fill: "url(#paint17_linear_190_1420)",
    id: "path487",
    style: {
      fill: "url(#paint17_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 174.38172,213.86306 c -0.623,-0.344 -1.086,-0.918 -1.29,-1.6 l 0.72,-0.2 c 0.169,0.5 0.528,0.914 1,1.15 z m -0.63,-2.58 -0.75,-0.06 c 0.074,-0.653 0.267,-1.287 0.57,-1.87 l 0.68,0.34 c -0.264,0.495 -0.433,1.034 -0.5,1.59 z",
    fill: "url(#paint18_linear_190_1420)",
    id: "path489",
    style: {
      fill: "url(#paint18_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 189.50172,216.50306 -0.74,-0.13 c 0.035,-0.181 0.052,-0.366 0.05,-0.55 0.023,-0.32 -0.074,-0.637 -0.27,-0.89 l 0.58,-0.48 c 0.302,0.391 0.457,0.876 0.44,1.37 -0.002,0.228 -0.022,0.455 -0.06,0.68 z m -10.63,-1.73 h -0.78 v -0.75 c 0.596,0.03 1.194,0.03 1.79,0 v 0.75 z m 2,-0.08 v -0.75 c 0.61,0 1.22,-0.1 1.81,-0.16 l 0.07,0.75 z m -3.71,0 h -0.31 c -0.526,-0.069 -1.045,-0.186 -1.55,-0.35 l 0.24,-0.71 c 0.458,0.153 0.93,0.26 1.41,0.32 h 0.29 z m 10.8,-0.15 c -0.536,-0.173 -1.097,-0.254 -1.66,-0.24 v -0.8 c 0.655,-0.017 1.308,0.081 1.93,0.29 z m -4.35,-0.09 -0.07,-0.75 c 0.64,-0.06 1.26,-0.11 1.83,-0.14 v 0.75 c -0.53,0 -1.14,0.05 -1.77,0.11 z",
    fill: "url(#paint19_linear_190_1420)",
    id: "path491",
    style: {
      fill: "url(#paint19_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 188.88172,218.40306 -0.69,-0.3 c 0.14,-0.32 0.26,-0.63 0.35,-0.9 l 0.71,0.23 c -0.1,0.3 -0.22,0.62 -0.37,0.97 z",
    fill: "url(#paint20_linear_190_1420)",
    id: "path493",
    style: {
      fill: "url(#paint20_linear_190_1420)"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m 216.63172,92.573061 h -23 c -0.74,0.013 -1.474,-0.132 -2.154,-0.425 -0.679,-0.293 -1.289,-0.727 -1.787,-1.274 -0.499,-0.547 -0.875,-1.194 -1.104,-1.897 -0.23,-0.704 -0.306,-1.448 -0.225,-2.184 l 2,-23 c 0.159,-1.565 0.885,-3.017 2.043,-4.082 1.157,-1.065 2.664,-1.669 4.237,-1.698 h 23 c 0.74,-0.013 1.474,0.132 2.154,0.425 0.679,0.293 1.289,0.727 1.787,1.274 0.499,0.547 0.875,1.194 1.104,1.897 0.23,0.704 0.306,1.448 0.225,2.184 l -2,23 c -0.159,1.565 -0.885,3.017 -2.043,4.082 -1.157,1.065 -2.664,1.669 -4.237,1.698 z",
    fill: "#000000",
    id: "path495"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m 213.63172,89.573061 h -23 c -0.74,0.013 -1.474,-0.132 -2.154,-0.425 -0.679,-0.293 -1.289,-0.727 -1.787,-1.274 -0.499,-0.547 -0.875,-1.194 -1.104,-1.897 -0.23,-0.704 -0.306,-1.448 -0.225,-2.184 l 2,-23 c 0.159,-1.565 0.885,-3.017 2.043,-4.082 1.157,-1.065 2.664,-1.669 4.237,-1.698 h 23 c 0.74,-0.013 1.474,0.132 2.154,0.425 0.679,0.293 1.289,0.727 1.787,1.274 0.499,0.547 0.875,1.194 1.104,1.897 0.23,0.704 0.306,1.448 0.225,2.184 l -2,23 c -0.159,1.565 -0.885,3.017 -2.043,4.082 -1.157,1.065 -2.664,1.669 -4.237,1.698 z",
    fill: "#ffffff",
    id: "path497"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 214.86172,76.973061 c -0.151,-4.047 -1.732,-7.91 -4.462,-10.901 -2.73,-2.992 -6.432,-4.919 -10.448,-5.439 -1.175,-0.578 -2.513,-0.733 -3.789,-0.437 -1.275,0.295 -2.41,1.022 -3.211,2.057 -2,2.43 -0.22,4 2,5.74 2.22,1.74 4.21,3.07 6.18,0.64 0.739,-0.889 1.195,-1.979 1.31,-3.13 1.847,0.754 3.502,1.91 4.846,3.384 1.344,1.473 2.343,3.228 2.924,5.136 -1.149,0.005 -2.27,0.354 -3.22,1 -2.59,1.76 -1.45,3.81 0.1,6.24 1.55,2.43 2.93,4.31 5.51,2.54 1.101,-0.708 1.927,-1.772 2.338,-3.015 0.411,-1.243 0.384,-2.59 -0.078,-3.815 z",
    fill: "url(#paint21_linear_190_1420)",
    id: "path499",
    style: {
      fill: "url(#paint21_linear_190_1420)"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m 205.23172,25.263061 h 15.7 c 0.78,0 0.88,-1.2 0.11,-1.2 h -15.68 c -0.77,0 -0.88,1.2 -0.11,1.2 z",
    fill: "#ffffff",
    id: "path501"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m 226.68172,25.263061 h 4.55 c 0.78,0 0.88,-1.2 0.11,-1.2 h -4.51 c -0.77,0 -0.88,1.2 -0.1,1.2 z",
    fill: "#ffffff",
    id: "path503"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    id: "g507",
    transform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 254,140.76 h 15.7 c 0.78,0 0.88,-1.2 0.11,-1.2 h -15.68 c -0.77,0 -0.88,1.2 -0.11,1.2 z",
    fill: "#ffffff",
    id: "path505"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    id: "g511",
    transform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 275.45,140.76 H 280 c 0.78,0 0.88,-1.2 0.11,-1.2 h -4.51 c -0.77,0 -0.88,1.2 -0.1,1.2 z",
    fill: "#ffffff",
    id: "path509"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m 256.93172,146.57306 -1.38,15.68 c -0.013,0.159 0.037,0.317 0.14,0.439 0.103,0.122 0.251,0.198 0.41,0.211 0.159,0.013 0.317,-0.037 0.439,-0.14 0.122,-0.103 0.198,-0.251 0.211,-0.41 0.453,-5.22 0.91,-10.447 1.37,-15.68 -0.002,-0.149 -0.06,-0.292 -0.161,-0.4 -0.102,-0.109 -0.24,-0.177 -0.389,-0.189 -0.148,-0.013 -0.296,0.031 -0.414,0.121 -0.119,0.09 -0.199,0.222 -0.226,0.368 z",
    fill: "#ffffff",
    id: "path513"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m 255.05172,167.99306 -0.39,4.51 c 0.002,0.149 0.06,0.292 0.161,0.401 0.102,0.108 0.24,0.176 0.389,0.188 0.148,0.013 0.296,-0.031 0.414,-0.121 0.118,-0.09 0.199,-0.222 0.226,-0.368 l 0.39,-4.5 c 0,-0.15 -0.056,-0.294 -0.156,-0.405 -0.101,-0.111 -0.24,-0.18 -0.389,-0.193 -0.149,-0.014 -0.298,0.028 -0.417,0.119 -0.12,0.09 -0.201,0.222 -0.228,0.369 z",
    fill: "#ffffff",
    id: "path515"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    id: "g519",
    transform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 305.7,262.07 -1.38,15.68 c -0.013,0.159 0.037,0.317 0.14,0.439 0.103,0.122 0.251,0.198 0.41,0.211 0.159,0.013 0.317,-0.037 0.439,-0.14 0.122,-0.103 0.198,-0.251 0.211,-0.41 0.453,-5.22 0.91,-10.447 1.37,-15.68 -0.002,-0.149 -0.06,-0.292 -0.161,-0.4 -0.102,-0.109 -0.24,-0.177 -0.389,-0.189 -0.148,-0.013 -0.296,0.031 -0.414,0.121 -0.119,0.09 -0.199,0.222 -0.226,0.368 z",
    fill: "#ffffff",
    id: "path517"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    id: "g523",
    transform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 303.82,283.49 -0.39,4.51 c 0.002,0.149 0.06,0.292 0.161,0.401 0.102,0.108 0.24,0.176 0.389,0.188 0.148,0.013 0.296,-0.031 0.414,-0.121 0.118,-0.09 0.199,-0.222 0.226,-0.368 l 0.39,-4.5 c 0,-0.15 -0.056,-0.294 -0.156,-0.405 -0.101,-0.111 -0.24,-0.18 -0.389,-0.193 -0.149,-0.014 -0.298,0.028 -0.417,0.119 -0.12,0.09 -0.201,0.222 -0.228,0.369 z",
    fill: "#ffffff",
    id: "path521"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 118.08172,76.793061 c 0,0 -5.8,-0.79 -5.1,2.23 0.51,2.2 2.46,-2.13 5.1,-2.23 z",
    fill: "url(#paint22_linear_190_1420)",
    id: "path525",
    style: {
      fill: "url(#paint22_linear_190_1420)"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m 113.04172,83.653061 c 0,0 4.78,-0.05 5.52,-8.76 0,0 4.56,-1.59 7.15,1.25 2.59,2.84 -3.36,8.34 -0.08,11.2 0,0 -3.28,1.79 -12.59,-3.69 z",
    fill: "#ff8b7b",
    id: "path527"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 130.73172,52.883061 c 0,0 6.16,-1.32 7.76,3.21 1.6,4.53 -9.12,2.54 -9.12,2.54 z",
    fill: "url(#paint23_linear_190_1420)",
    id: "path529",
    style: {
      fill: "url(#paint23_linear_190_1420)"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m 130.73172,52.883061 c 0,0 6.16,-1.32 7.76,3.21 1.6,4.53 -9.12,2.54 -9.12,2.54 z",
    fill: "#000000",
    id: "path531"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 135.77172,64.173061 c 0.1,-0.58 0.48,-1 0.86,-0.93 0.38,0.07 0.61,0.58 0.51,1.16 -0.1,0.58 -0.49,1 -0.86,0.94 -0.37,-0.06 -0.61,-0.59 -0.51,-1.17 z",
    fill: "url(#paint24_linear_190_1420)",
    id: "path533",
    style: {
      fill: "url(#paint24_linear_190_1420)"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m 136.07172,65.263061 2.69,4.36 c -0.51,0.315 -1.088,0.505 -1.685,0.556 -0.598,0.05 -1.199,-0.041 -1.755,-0.266 z",
    fill: "#ff5652",
    id: "path535"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m 115.70172,61.373061 c -0.34,7.41 -0.64,10.55 2.67,14.72 5.27,4.46 14.17,5.08 16.71,-2.09 2.29,-6.44 2.46,-17.45 -4.44,-21.19 -1.516,-0.823 -3.218,-1.244 -4.943,-1.224 -1.725,0.02 -3.417,0.481 -4.914,1.339 -1.496,0.857 -2.749,2.083 -3.639,3.562 -0.89,1.478 -1.387,3.159 -1.444,4.883 z",
    fill: "#ff8b7b",
    id: "path537"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 134.84172,62.343061 c 0.049,0.027 0.104,0.041 0.16,0.041 0.056,0 0.111,-0.014 0.16,-0.041 0.344,-0.26 0.744,-0.435 1.168,-0.512 0.424,-0.076 0.86,-0.052 1.272,0.072 0.084,0.033 0.177,0.031 0.259,-0.004 0.083,-0.036 0.148,-0.103 0.181,-0.186 0.033,-0.085 0.032,-0.18 -0.003,-0.264 -0.036,-0.084 -0.103,-0.151 -0.187,-0.186 -0.519,-0.168 -1.071,-0.209 -1.608,-0.119 -0.538,0.091 -1.047,0.31 -1.482,0.639 -0.037,0.023 -0.069,0.054 -0.094,0.09 -0.025,0.036 -0.043,0.076 -0.052,0.119 -0.01,0.043 -0.01,0.087 -0.002,0.13 0.008,0.043 0.024,0.084 0.048,0.121 0.047,0.053 0.11,0.089 0.18,0.1 z",
    fill: "url(#paint25_linear_190_1420)",
    id: "path539",
    style: {
      fill: "url(#paint25_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 109.68172,85.153061 c 0,0 2.06,-5.69 10.59,-2.06 8.53,3.63 9.33,8.63 9.33,8.63 z",
    fill: "url(#paint26_linear_190_1420)",
    id: "path541",
    style: {
      fill: "url(#paint26_linear_190_1420)"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m 109.68172,85.153061 c 0,0 2.06,-5.69 10.59,-2.06 8.53,3.63 9.33,8.63 9.33,8.63 z",
    fill: "#000000",
    id: "path543"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m 113.51172,192.99306 c 0,0 -1.21,10.37 -1.79,13.8 -0.52,3 -16.999997,81.7 -16.999997,81.7 l -7.49,-1.24 c 0,0 -0.83,-39.87 4.94,-66.26 1.19,-5.4 3.58,-9.92 4.45,-14.05 0.7,-3.31 -0.36,-13.55 -0.36,-13.55 z",
    fill: "#ff8b7b",
    id: "path545"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m 82.231723,191.30306 c 0,0 -3.49,9.5 -5.12,12.44 -1.77,3.2 -8.49,11.91 -8.49,11.91 l -35.8,50.23 -6.85,-4.33 c 0,0 10.33,-27.66 25.89,-50.18 3.71,-5.37 9.05,-9.46 12,-14.79 1.67,-3.06 3.09,-13.62 3.09,-13.62 z",
    fill: "#ff8b7b",
    id: "path547"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m 91.831723,95.143061 c 0,0 -8.57,10.929999 -7.84,15.519999 0.73,4.59 14.16,10.18 14.16,10.18 l 3.409997,-4.85 -8.819997,-6.44 8.399997,-9.629999 z",
    fill: "#ff8b7b",
    id: "path549"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 106.00172,84.203061 c -1.07,-0.51 -5.82,-2.41 -16.069997,10.91 0,0 3.73,4.65 11.719997,7.419999 0,-0.03 9,-16.159999 4.35,-18.329999 z",
    fill: "url(#paint27_linear_190_1420)",
    id: "path551",
    style: {
      fill: "url(#paint27_linear_190_1420)"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m 101.65172,102.50306 c 0,0 1.5,-2.679999 3,-5.999999 -0.24,-5.71 -0.94,-12.8 -2.94,-10.25 -2.659997,3.38 -6.339997,10.19 -7.549997,12.47 2.315,1.591999 4.835,2.862999 7.489997,3.779999 z",
    fill: "#000000",
    id: "path553"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m 93.581723,128.50306 c 9.849997,5.317 20.730997,8.448 31.899997,9.18 l -11.56,64.41 c 0,0 -33.339997,-0.11 -50.769997,-16.67 0,-0.04 6.95,-35.14 30.43,-56.92 z",
    fill: "#ffffff",
    id: "path555"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 92.171723,128.64306 c 0,0 13.349997,9.84 34.609997,9.17 0,0 12.21,-33.78 4.56,-45.209999 -4.73,-7.06 -22.89,-10.25 -27.78,-8.24 -5.889997,2.42 -2.48,23.599999 -11.389997,44.279999 z",
    fill: "url(#paint28_linear_190_1420)",
    id: "path557",
    style: {
      fill: "url(#paint28_linear_190_1420)"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m 95.371723,163.34306 -14.85,32.47 c 5.207,1.891 10.557,3.359 16,4.39 0,0 0.5,-30.33 -1.15,-36.86 z",
    fill: "#000000",
    id: "path559"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m 125.74172,98.133061 -2.36,1.74 c 1.89,6.576999 4.864,12.791999 8.8,18.389999 1.01,-4.713 1.569,-9.511 1.67,-14.33 l -5.26,-4.429999 z",
    fill: "#000000",
    id: "path561"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m 139.12172,103.01306 8,11.15 20.11,1.34 3.69,-3.07 c 0.245,-0.208 0.55,-0.334 0.87,-0.36 l 10.74,-0.85 c 0.077,-0.004 0.155,0.008 0.227,0.035 0.072,0.028 0.138,0.07 0.193,0.125 0.055,0.055 0.097,0.121 0.125,0.193 0.027,0.072 0.039,0.15 0.035,0.227 l -0.06,0.91 c -0.011,0.13 -0.067,0.252 -0.158,0.345 -0.091,0.093 -0.212,0.152 -0.342,0.165 l -5.09,0.4 -1,5.21 c -0.058,0.293 -0.198,0.564 -0.403,0.782 -0.205,0.218 -0.467,0.373 -0.757,0.448 l -4,1 c -0.255,0.07 -0.525,0.07 -0.78,0 l -2.82,-0.71 c 0,0 -15.67,3.16 -22.86,1.89 -7.19,-1.27 -14.28,-13 -14.28,-13 z",
    fill: "#ff8b7b",
    id: "path563"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 129.86172,111.50306 c 0,0 -12.88,-17.229999 -4.93,-21.229999 7.95,-4 16.3,13.699999 16.3,13.699999 0,0 -3.26,4.98 -11.37,7.53 z",
    fill: "url(#paint29_linear_190_1420)",
    id: "path565",
    style: {
      fill: "url(#paint29_linear_190_1420)"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m 96.361723,288.04306 c -0.038,-0.008 -0.073,-0.028 -0.1,-0.056 -0.027,-0.029 -0.044,-0.065 -0.05,-0.104 -0.006,-0.041 10e-4,-0.083 0.018,-0.12 0.018,-0.038 0.047,-0.069 0.082,-0.09 0.13,-0.06 3.08,-1.61 4.449997,-1.17 0.127,0.036 0.245,0.098 0.348,0.18 0.103,0.082 0.189,0.184 0.252,0.3 0.09,0.123 0.139,0.272 0.139,0.425 0,0.153 -0.049,0.302 -0.139,0.425 -0.721,0.477 -1.593997,0.67 -2.449997,0.54 -0.858,-0.029 -1.712,-0.139 -2.55,-0.33 z m 0.65,-0.24 c 1.53,0.25 3.619997,0.32 3.999997,-0.21 0.06,-0.06 0.12,-0.18 0,-0.43 -0.036,-0.073 -0.088,-0.136 -0.152,-0.187 -0.064,-0.05 -0.139,-0.085 -0.218,-0.103 -0.122,-0.04 -0.251,-0.06 -0.38,-0.06 -1.135997,0.121 -2.238997,0.457 -3.249997,0.99 z",
    fill: "#ffffff",
    id: "path567"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m 96.231723,288.03306 c -0.029,-0.019 -0.053,-0.046 -0.067,-0.078 -0.014,-0.032 -0.019,-0.067 -0.013,-0.102 0,-0.11 0.32,-2.33 1.4,-3.16 0.156,-0.12 0.335,-0.208 0.526,-0.258 0.19,-0.05 0.389,-0.061 0.584,-0.032 0.54,0.07 0.69,0.35 0.71,0.58 0.14,0.93 -1.92,2.65 -2.93,3.06 h -0.08 c -0.043,0.011 -0.089,0.008 -0.13,-0.01 z m 2.28,-3.27 c -0.246,-0.013 -0.488,0.065 -0.68,0.22 -0.649,0.689 -1.068,1.563 -1.2,2.5 1,-0.57 2.41,-1.92 2.38,-2.49 0,-0.05 0,-0.19 -0.38,-0.23 z",
    fill: "#ffffff",
    id: "path569"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 95.561723,286.85306 -9,-0.34 c -0.166,-0.005 -0.329,0.047 -0.462,0.147 -0.132,0.1 -0.227,0.242 -0.268,0.403 l -1.91,7.29 c -0.083,0.309 -0.04,0.638 0.12,0.915 0.159,0.278 0.422,0.481 0.73,0.565 0.086,0.015 0.174,0.015 0.26,0 3.26,0.07 6.16,0 10.22,0.16 4.789997,0.18 3.55,0.7 9.179997,1 3.39,0.17 4.15,-3.66 2.72,-3.9 -6.55,-1.07 -7.159997,-3.09 -9.609997,-5.54 -0.554,-0.464 -1.257,-0.713 -1.98,-0.7 z",
    fill: "url(#paint30_linear_190_1420)",
    id: "path571",
    style: {
      fill: "url(#paint30_linear_190_1420)"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m 33.941823,266.37306 c -0.0292,-0.028 -0.0502,-0.063 -0.0607,-0.102 -0.0106,-0.038 -0.0104,-0.079 7e-4,-0.118 0.0126,-0.038 0.0367,-0.071 0.069,-0.094 0.0323,-0.023 0.0711,-0.036 0.111,-0.036 0.15,0 3.48,0 4.51,1 0.1929,0.188 0.3073,0.441 0.32,0.71 0.02,0.151 -0.0079,0.305 -0.0796,0.439 -0.0717,0.135 -0.1838,0.243 -0.3204,0.311 -0.8631,0.096 -1.7315,-0.128 -2.44,-0.63 -0.7467,-0.428 -1.4529,-0.924 -2.11,-1.48 z m 0.69,0.08 c 1.25,0.91 3.09,1.91 3.69,1.62 0.08,0 0.18,-0.1 0.17,-0.39 8e-4,-0.082 -0.0167,-0.163 -0.0513,-0.238 -0.0346,-0.074 -0.0854,-0.14 -0.1487,-0.192 -0.0924,-0.088 -0.1968,-0.162 -0.31,-0.22 -1.0738,-0.384 -2.21,-0.564 -3.35,-0.53 z",
    fill: "#ffffff",
    id: "path573"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m 33.861923,266.31306 c -0.0198,-0.03 -0.0303,-0.064 -0.0303,-0.1 0,-0.036 0.0105,-0.07 0.0303,-0.1 0.06,-0.08 1.33,-1.93 2.68,-2.18 0.191,-0.038 0.3876,-0.037 0.5782,0.003 0.1907,0.039 0.3714,0.117 0.5318,0.227 0.45,0.31 0.47,0.63 0.38,0.84 -0.3,0.9 -2.91,1.51 -4,1.42 -0.0259,0.009 -0.0541,0.009 -0.08,0 -0.0431,-0.024 -0.0754,-0.063 -0.09,-0.11 z m 3.51,-1.88 c -0.2136,-0.127 -0.4667,-0.169 -0.71,-0.12 -0.8902,0.328 -1.6581,0.921 -2.2,1.7 1.2,0 3,-0.64 3.25,-1.15 0,-0.05 0.06,-0.19 -0.24,-0.39 h -0.1 z",
    fill: "#ffffff",
    id: "path575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 33.761823,264.95306 -7.91,-4.38 c -0.1447,-0.081 -0.3127,-0.11 -0.4763,-0.083 -0.1636,0.027 -0.313,0.109 -0.4237,0.233 l -5,5.65 c -0.1065,0.118 -0.1886,0.256 -0.2417,0.406 -0.0531,0.15 -0.0762,0.309 -0.0678,0.468 0.0084,0.158 0.048,0.314 0.1165,0.458 0.0686,0.143 0.1647,0.272 0.283,0.378 l 0.21,0.15 c 2.88,1.53 5.51,2.78 9.06,4.75 4.19,2.32 2.85,2.23 7.74,5 3,1.69 5.36,-1.39 4.19,-2.25 -5.36,-3.91 -5,-6 -6.08,-9.28 -0.2759,-0.649 -0.7715,-1.18 -1.4,-1.5 z",
    fill: "url(#paint31_linear_190_1420)",
    id: "path577",
    style: {
      fill: "url(#paint31_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 128.23172,67.743061 c 0,0 3,-1 1.9,-5.35 0,0 1.77,-3 1.49,-4.59 0,0 9,-5.19 3.86,-10.88 -5.14,-5.69 -14.47,-1.89 -18.6,5.38 0,0 -21.949997,7.14 -6.67,20.56 14.87,13.11 18.02,-5.12 18.02,-5.12 z",
    fill: "url(#paint32_linear_190_1420)",
    id: "path579",
    style: {
      fill: "url(#paint32_linear_190_1420)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 119.17172,55.353061 c 0,0 -3.43,-7.53 1.72,-13.22 5.15,-5.69 -3.42,8.02 -1.72,13.22 z",
    fill: "url(#paint33_linear_190_1420)",
    id: "path581",
    style: {
      fill: "url(#paint33_linear_190_1420)"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m 128.23172,67.743061 c 0.085,-0.028 0.169,-0.061 0.25,-0.1 0,-5.64 -2.17,-12.4 -10.49,-17 -0.4,0.54 -0.77,1.1 -1.11,1.68 0,0 -0.63,0.21 -1.6,0.61 2.88,3.06 10.79,13.19 1.9,24.26 8.91,2.78 11.05,-9.45 11.05,-9.45 z",
    fill: "#ffffff",
    id: "path583"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m 128.58172,65.103061 c 1.021,1.119 1.557,2.597 1.49,4.11 -0.11,2 -2.07,2.39 -3.63,1.31 -1.41,-1 -3.05,-3.2 -2.17,-5 0.198,-0.382 0.489,-0.709 0.845,-0.95 0.356,-0.241 0.768,-0.39 1.196,-0.431 0.428,-0.042 0.861,0.024 1.257,0.192 0.396,0.168 0.744,0.432 1.012,0.769 z",
    fill: "#ff8b7b",
    id: "path585"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 136.49172,63.253061 1.62,-0.08 c 0,0 -1.06,1.01 -1.62,0.08 z",
    fill: "url(#paint34_linear_190_1420)",
    id: "path587",
    style: {
      fill: "url(#paint34_linear_190_1420)"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m 121.66172,78.173061 c 0.812,1.64 2.061,3.025 3.61,4 0.35,-0.907 0.654,-1.832 0.91,-2.77 -1.566,-0.147 -3.095,-0.563 -4.52,-1.23 z",
    fill: "#000000",
    id: "path589"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs766"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_190_1420",
    x1: 291.69101,
    y1: 185.57201,
    x2: 307.50201,
    y2: 184.644,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#252525",
    id: "stop593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_190_1420",
    x1: 303.31699,
    y1: 176.416,
    x2: 306.96399,
    y2: 175.46001,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#252A2D",
    id: "stop598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_190_1420",
    x1: 294.897,
    y1: 178.202,
    x2: 298.47699,
    y2: 177.683,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#232424",
    id: "stop603"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_190_1420",
    x1: 304.39001,
    y1: 180.836,
    x2: 306.01599,
    y2: 180.75,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#232424",
    id: "stop608"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_190_1420",
    x1: 297.39401,
    y1: 181.92599,
    x2: 299.026,
    y2: 181.839,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#232424",
    id: "stop613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_190_1420",
    x1: 296.599,
    y1: 180.334,
    x2: 298.19199,
    y2: 179.95599,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#232424",
    id: "stop618"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_190_1420",
    x1: 303.58899,
    y1: 179.229,
    x2: 305.17599,
    y2: 178.839,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#232424",
    id: "stop623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_190_1420",
    x1: 302.487,
    y1: 189.282,
    x2: 308.53201,
    y2: 187.631,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#2F363C",
    id: "stop628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_190_1420",
    x1: 352.01001,
    y1: 401.858,
    x2: 352.01001,
    y2: 411.25101,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_190_1420",
    x1: 340.509,
    y1: 236.625,
    x2: 340.509,
    y2: 395.771,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_190_1420",
    x1: 422.255,
    y1: 374.65201,
    x2: 422.255,
    y2: 391.478,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop643"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_190_1420",
    x1: 376.84799,
    y1: 240.21001,
    x2: 376.84799,
    y2: 374.668,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop648"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_190_1420",
    x1: 232.88,
    y1: 219.16,
    x2: 232.88,
    y2: 241.067,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop653"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_190_1420",
    x1: 248.134,
    y1: 225.44,
    x2: 248.134,
    y2: 243.437,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_190_1420",
    x1: 257.47198,
    y1: 267.58899,
    x2: 257.47198,
    y2: 288.72,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop663"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_190_1420",
    x1: 228.77499,
    y1: 310.92999,
    x2: 228.77499,
    y2: 325.25,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop668"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_190_1420",
    x1: 227.10001,
    y1: 320.12,
    x2: 227.10001,
    y2: 323.42001,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop673"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_190_1420",
    x1: 223.41,
    y1: 323.17999,
    x2: 223.41,
    y2: 324.42999,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop678"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_190_1420",
    x1: 222.675,
    y1: 324.85001,
    x2: 222.675,
    y2: 329.35999,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop683"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_190_1420",
    x1: 231.2,
    y1: 328.99799,
    x2: 231.2,
    y2: 332,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop688"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_190_1420",
    x1: 237.49001,
    y1: 332.70001,
    x2: 237.49001,
    y2: 333.89999,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop693"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_190_1420",
    x1: 252.424,
    y1: 175.54601,
    x2: 252.424,
    y2: 199.99699,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop698"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_190_1420",
    x1: 164.271,
    y1: 192.19701,
    x2: 164.271,
    y2: 195.14301,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_190_1420",
    x1: 182.782,
    y1: 168.201,
    x2: 182.782,
    y2: 174.565,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop708"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_190_1420",
    x1: 185.22501,
    y1: 178.73199,
    x2: 185.22501,
    y2: 180.84599,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop713"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_190_1420",
    x1: 185.105,
    y1: 176.59399,
    x2: 185.105,
    y2: 177.881,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop718"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_190_1420",
    x1: 168.41,
    y1: 197.379,
    x2: 168.41,
    y2: 207.22,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop723"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_190_1420",
    x1: 147.40199,
    y1: 199.30901,
    x2: 147.40199,
    y2: 218.03,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop728"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_190_1420",
    x1: 161.785,
    y1: 199.267,
    x2: 161.785,
    y2: 253.343,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_190_1420",
    x1: 180.55499,
    y1: 205.181,
    x2: 180.55499,
    y2: 227,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_190_1420",
    x1: 144.627,
    y1: 402.01001,
    x2: 144.627,
    y2: 412.496,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_190_1420",
    x1: 79.362297,
    y1: 375.97699,
    x2: 79.362297,
    y2: 393.978,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_190_1420",
    x1: 153.123,
    y1: 187.123,
    x2: 187.953,
    y2: 184.464,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343535",
    id: "stop753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_190_1420",
    x1: 166.758,
    y1: 168.243,
    x2: 171.64999,
    y2: 168.123,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#1F2122",
    id: "stop758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_190_1420",
    x1: 186.07001,
    y1: 178.67,
    x2: 186.07001,
    y2: 179.14301,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-48.768277,-115.49694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44CACB",
    id: "stop761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16629C",
    id: "stop763"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetInTouch);
export default __webpack_public_path__ + "static/media/get-in-touch.d89a34b9f118d485376205e76b01aa22.svg";
export { ForwardRef as ReactComponent };